import { ActivityOptions, DateTypeFilter, Severity } from "@gripp/shared-logic";

// Helper function to count active activity filters
export const countFilters = (filter: any) => {
  if (!filter) return 0;
  
  let count = 0;
  
  // Count groups
  if (filter.groupIds && filter.groupIds.length > 0) {
    count++;
  }
  
  // Count labels
  if (filter.labelIds && filter.labelIds.length > 0) {
    count++;
  }
  
  // Count severity (if not all severities selected)
  if (filter.severity && filter.severity.length > 0) {
    const allSeverities = Object.values(Severity);
    const hasAllSeverities = 
      filter.severity.length === allSeverities.length &&
      allSeverities.every(s => filter.severity?.includes(s));
    if (!hasAllSeverities) {
      count++;
    }
  }
  
  // Count activity option (if not EVERYTHING)
  if (filter.activityOption && filter.activityOption !== ActivityOptions.EVERYTHING) {
    count++;
  }
  
  // Count date type (if not ALL)
  if (filter.dateType && filter.dateType !== DateTypeFilter.ALL) {
    count++;
  }
  
  // Count groups (only filter for assets)
  if (filter.groups && filter.groups.length > 0) {
    count++;
  }
  
  return count;
};